import { COMPONENTS } from '../../../components/components.registry';
import { OpenConfig } from '../../../models';

export const DEFAULT_OPEN_CONFIG: OpenConfig = {
  components: {
    open: COMPONENTS.PURE.DefaultOpen
  },
  triggersSelector: '.open',
  triggerEvent: 'click',
  delegateEvent: true
};
